import React from 'react';
import ShareBtn from './ShareBtn';
import './Header.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function Header() {
    return (
        <div>
        <nav className="sticky__nav">
            <img src="/VialSelector/images/Web_Plexus_Corner.png" className="bg-header" alt="Web_Plexus_Corner"/>
            <ul>
                <li>
                    <a href="http://www.waters.com/" target="_blank" >
                        <img src="/VialSelector/images/waters-logo-white_5.svg" alt="Waters logo white" className="c-logo"/>
                    </a>
                </li>
                <li className="drop" id="drop">
                    <ul className="sticky__navel">
                        {/* <li id="pns"><a href='https://find.waters.com/PartNumberSelector/' target="_blank">
                            Part Number Selector</a></li> */}
                        <ShareBtn />
                        {/* <li id="contactUs"><a href='http://www.waters.com/waters/en_US/Contact-Waters-US/nav.htm?localContactPage=Y&type=contact_us&cid=10007862' target="_blank">
                        Request Information</a></li> */}
                    </ul>
                </li>
            </ul>
        </nav>
        <header className="header">
            <div className="page">
                <h3 className="padding-6 padding-btn-no">The Vial Selector</h3>
            </div>
        </header>
        </div>
    );
}

export default Header;